import FieldConfig from "../../../proto/field-config";
import FieldTotal from "../total/total";
import FieldMessagesTotal_TableCell from "./render/table/table-cell";
import FieldMessagesTotal_TableCellCalculated from "./render/table/calculated/table-cell-calculated";

export default class FieldMessagesTotal extends FieldTotal {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel                              = "Messages"
        this.typeDescription                        = "Messages"
        this.icon                                   = 'i5-chat'

        this.renderComponents.tableCell             = FieldMessagesTotal_TableCell
        this.renderComponents.tableCellCalculated   = FieldMessagesTotal_TableCellCalculated
    }
}
